import React, { lazy, Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import { Footer, Header } from "../components/common";
const HelpModal = lazy(() => import("../components/BookingForm/HelpModal"));

const DefaultLayout: React.FC = () => {
  const [showHelp, setShowHelp] = useState(false);
  return (
    <>
      <Header onHelpClick={() => setShowHelp(true)} />
      <Outlet />
      <Footer />
      <Suspense fallback={null}>
        <HelpModal isOpen={showHelp} onClose={() => setShowHelp(false)} />
      </Suspense>
    </>
  );
};

export default DefaultLayout;
